import { render, staticRenderFns } from "./ARadioGroup.vue?vue&type=template&id=d4dd128a&"
import script from "./ARadioGroup.vue?vue&type=script&lang=js&"
export * from "./ARadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports